module.exports = __webpack_public_path__ + "static/img/longin_style2.e6b8272b.png";